import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, vModelText as _vModelText, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card-body py-3" }
const _hoisted_2 = { class: "card-title align-items-start flex-column mb-5 mt-5" }
const _hoisted_3 = {
  key: 0,
  class: "card-label fw-bolder fs-3 "
}
const _hoisted_4 = {
  key: 1,
  class: "card-label fw-bolder fs-3 "
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("option", { value: "PR" }, "Product GC", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("option", { value: "TV" }, "Travel GC", -1)
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = { class: "col-md-4" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createVNode("div", { class: "position-relative" })
], -1)
const _hoisted_15 = {
  key: 0,
  class: "card-body py-3 mt-5"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column mb-5 mt-5" }, [
  /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 " }, "Redeem Sodexo       ")
], -1)
const _hoisted_17 = { class: "row" }
const _hoisted_18 = /*#__PURE__*/_createVNode("p", { class: "mb-5 mt-5" }, [
  /*#__PURE__*/_createTextVNode("Sodexo Releasing Branch (Sodexo GC will be released "),
  /*#__PURE__*/_createVNode("span", { class: "badge badge-success" }, " 6 working days "),
  /*#__PURE__*/_createTextVNode(" after you redeem in the branch you specified.)")
], -1)
const _hoisted_19 = {
  class: "border border-gray-300 border-dashed rounded min-w-275px py-3 px-4 me-6 mb-5 col-md-3",
  align: "center"
}
const _hoisted_20 = { align: "center" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_22 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_23 = { class: "fw-bold fs-6 text-gray-400" }
const _hoisted_24 = {
  key: 0,
  class: "row"
}
const _hoisted_25 = { class: "col-md-4 fv-row" }
const _hoisted_26 = { class: "col-md-4 fv-row" }
const _hoisted_27 = /*#__PURE__*/_createVNode("option", { value: "" }, "Select Branch", -1)
const _hoisted_28 = { class: "col-md-4 fv-row" }
const _hoisted_29 = {
  key: 0,
  class: "position-relative"
}
const _hoisted_30 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_31 = {
  key: 1,
  class: "row"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card"]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("h3", _hoisted_2, [
          (_ctx.gc_type == 'PR')
            ? (_openBlock(), _createBlock("span", _hoisted_3, "Redeem Product GC       "))
            : _createCommentVNode("", true),
          (_ctx.gc_type == 'TV')
            ? (_openBlock(), _createBlock("span", _hoisted_4, "Redeem Travel GC       "))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              (_ctx.isallowedTravelGCRedeem)
                ? (_openBlock(), _createBlock("div", _hoisted_8, [
                    _withDirectives(_createVNode("select", {
                      class: "form-select form-select-solid col-md-4 mb-5",
                      id: "gc_type",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.gc_type = $event))
                    }, [
                      _hoisted_9,
                      _hoisted_10
                    ], 512), [
                      [_vModelSelect, _ctx.gc_type]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_11, [
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control form-control-solid",
                  placeholder: "Enter quantity here",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.gc_redeem = $event))
                }, null, 512), [
                  [_vModelText, _ctx.gc_redeem]
                ])
              ]),
              _createVNode("div", _hoisted_12, [
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-danger er fs-6 px-8 py-2",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.gc_redeem = '0'))
                }, " Cancel "),
                _hoisted_13,
                (_ctx.gcmodeldata.isEnabledCountryGCRedeemButton === true)
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-primary er fs-6 px-8 py-2",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.processGCRedeem();})
                    }, " Redeem "))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _hoisted_14
        ])
      ])
    ], 2), [
      [_vShow, !_ctx.loading]
    ]),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "col-md-12 card"]
    }, [
      (_ctx.gcmodeldata.countryCode == 0)
        ? (_openBlock(), _createBlock("div", _hoisted_15, [
            _hoisted_16,
            _createVNode("div", _hoisted_17, [
              _hoisted_18,
              _withDirectives(_createVNode("div", _hoisted_19, [
                _createVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createVNode("div", _hoisted_22, _toDisplayString(_ctx.availableSodexo), 1)
                ]),
                _createVNode("div", _hoisted_23, "  Available SODEXO for User ID (" + _toDisplayString(_ctx.usid) + ")", 1)
              ], 512), [
                [_vShow, !_ctx.loadingBalance]
              ])
            ]),
            (_ctx.gcmodeldata.isallowedSodexo)
              ? (_openBlock(), _createBlock("div", _hoisted_24, [
                  _createVNode("div", _hoisted_25, [
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control form-control-solid col-md-4 mb-5",
                      placeholder: "Enter quantity here",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.sodexo_quantity = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.sodexo_quantity]
                    ])
                  ]),
                  _createVNode("div", _hoisted_26, [
                    _withDirectives(_createVNode("select", {
                      class: "form-select form-select-solid col-md-4 mb-5",
                      id: "destination",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.branchcode_selected = $event))
                    }, [
                      _hoisted_27,
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.branches, (item, index) => {
                        return (_openBlock(), _createBlock("option", {
                          key: index,
                          value: item.branch_code
                        }, _toDisplayString(item.description), 9, ["value"]))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.branchcode_selected]
                    ])
                  ]),
                  _createVNode("div", _hoisted_28, [
                    (_ctx.isEnabledCountryGCRedeemButton)
                      ? (_openBlock(), _createBlock("div", _hoisted_29, [
                          _createVNode("button", {
                            type: "button",
                            class: "btn btn-danger er fs-6 px-8 py-2",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sodexo_quantity = '0'))
                          }, " Cancel "),
                          _hoisted_30,
                          (_ctx.gcmodeldata.isEnabledCountryGCRedeemButton === true)
                            ? (_openBlock(), _createBlock("button", {
                                key: 0,
                                type: "button",
                                class: "btn btn-primary er fs-6 px-8 py-2",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.process_sodexoredeem();})
                              }, " Redeem "))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.ccode == 0)
              ? (_openBlock(), _createBlock("div", _hoisted_31))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 2), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
}